<template>
    <div class="detail-box" v-if="courseId">
        <div class="top-box">
            <el-tooltip class="item" effect="dark" content="新增课程" placement="top-start">
                <img class="add" @click="toCreateCourse" v-if="$permission('myselfCourse::createCourse')"
                    src="../../../assets/image/course/add.png" alt="">
            </el-tooltip>
            <div class="one-box">
                <div class="onr-left">
                    <div class="img-box">
                        <video ref="video" id="audio" v-show="isPlay"
                            style="width: 70rem;height:36rem;object-fit: fill;" autoplay controls></video>
                        <el-image v-if="!isPlay" class="img-detail"
                            :src="detail.coverImageUrl ? $severUrl(detail.coverImageUrl) : $filterResDefault(detail.classifyCode)"
                            fit="cover"></el-image>
                        <div class="play-box" @click="playVideo" v-if="!isPlay && detail.introduceVideoPreviewUrl">
                            <i class="iconfont icon-weibiaoti518"></i>
                        </div>
                    </div>
                    <div class="name-box">
                        <p class="page-title overflow">{{ detail.courseName }}</p>
                        <div class="rate-box">
                            <el-rate v-model="detail.evaluateScore" disabled show-score text-color="#999999"
                                score-template="{value}">
                            </el-rate>
                            <div>({{ detail.evaluateCount }}人评价)</div>
                            <img class="ev-img ev" :src="ev" v-if="!detail.evaluate" @click="openDialog" alt="">
                            <i class="iconfont icon-chakan" style="font-size: 2rem;margin-left: 1rem;"></i>
                            <div class="ev-num">{{ detail.viewCount || 0 }}</div>
                        </div>
                    </div>
                </div>
                <div class="one-right">
                    <base-detail :id="courseId"></base-detail>
                </div>
            </div>
        </div>
        <div style="position: relative;">
            <div class="tab-box">
                <p class="title" @click="tabActive = 'introduce'" :class="{ 'tab-active': tabActive == 'introduce' }">课程介绍</p>
                <p class="title" @click="openCategory" :class="{ 'tab-active': tabActive == 'category' }">课程目录</p>
                <p class="title" @click="tabActive = 'data'" :class="{ 'tab-active': tabActive == 'data' }">课程数据</p>
                <p class="title" @click="tabActive = 'evaluate'" :class="{ 'tab-active': tabActive == 'evaluate' }">
                    {{ `课程评价（${evaluateNumber}）` }}</p>
            </div>
            <div class="bottom-box" v-if="tabActive == 'introduce'">
                <div>
                    <detail-left :id="courseId"></detail-left>
                </div>
                <div>
                    <detail-right :id="courseId"></detail-right>
                </div>
            </div>
            <div class="category-box" v-else-if="tabActive == 'category'">
                <div>
                    <category :categoryList="chapter" :id="courseId" v-if="chapter && chapter.length > 0"
                        style="margin-top: 4.4rem;"></category>
                    <no-data style="padding: 6.5rem 0;" v-else></no-data>
                </div>
            </div>
            <div class="course-data-box" v-else-if="tabActive == 'data'">
                <div>
                    <course-info :id="courseId"></course-info>
                    <show-charts :id="courseId"></show-charts>
                </div>
            </div>
            <div class="bottom-container" v-else>
                <div>
                    <evaluate businessType="course" :businessId="courseId" @get_total="getTotal" ref="evaluate">
                    </evaluate>
                </div>
            </div>
        </div>
        <study-evaluate @evaluate_success="evaluateSuccess" ref="evaluate0"></study-evaluate>
    </div>
</template>

<script>
import DetailLeft from '@/components/course/courseDetail/DetailLeft.vue';
import DetailRight from '@/components/course/courseDetail/DetailRight.vue';
import CourseInfo from '@/components/course/courseDetail/CourseInfo.vue';
import ShowCharts from '@/components/course/courseDetail/ShowCharts.vue';
import Category from '@/components/course/courseDetail/Category.vue';
import { PageQueryEvaluate } from '@/api/evaluate';
import Evaluate from '@/components/course/courseDetail/Evaluate.vue';
import { QueryCourseDetail } from '@/api/course';
import Hls from 'hls.js';
import { GetStudyChapterTree } from '@/api/courseChapter';
import { AddOptRecord } from '@/api/operation';
import StudyEvaluate from '@/components/course/courseDetail/StudyEvaluate.vue';
import NoData from '@/components/common/NoData.vue';
import { OPERATIONTYPE } from '@/utils/utils';
import BaseDetail from '@/components/course/courseDetail/BaseDetail.vue';
export default {
    props: ['courseId'],
    components: { DetailLeft, DetailRight, CourseInfo, ShowCharts, Category, Evaluate, StudyEvaluate, NoData, BaseDetail },
    data() {
        return {
            /**评分 */
            rateVal: 3,
            /**tab切换关键字 */
            tabActive: 'introduce',
            isPlay: false,
            /**评论数量 */
            evaluateNumber: 0,
            /**评论图标 */
            ev: require('../../../assets/image/operation/pl.png'),
            observer: null
        }
    },
    methods: {
        /**评价成功后刷新列表 */
        evaluateSuccess() {
            this.queryCourseDetail();
            var dom = this.$refs.evaluate;
            if (dom) {
                dom.courseEvaluateList();
            } else {
                this.courseEvaluateList();
            }
        },
        backRoute() {
            let path = this.$store.state.backend.lastRoutePath;
            if (path) {
                this.$router.push(path);
            } else {
                this.$router.push('/course');
            }
        },
        courseEvaluateList() {
            var params = {
                "businessId": this.courseId,
                "businessType": 'course',
                "evaluateType": "general",
            }
            PageQueryEvaluate(params).then(res => {
                if (res.code == 200) {
                    this.evaluateNumber = res.data.total;
                }
            })
        },
        /**获取评论数量 */
        getTotal(e) {
            this.evaluateNumber = e || 0;
        },
        /**编辑课程 */
        goEdit() {
            this.$router.push({
                path: '/course/createCourse',
                query: {
                    id: this.courseId,
                    operation: 'edit'
                }
            });
        },
        /**跳转创建课程页面 */
        toCreateCourse() {
            this.$store.commit('course/changeId', '');
            this.$router.push('/course/createCourse');
        },
        /**查看课程目录 */
        openCategory() {
            this.tabActive = 'category';
            this.getChapterTree();
        },
        /**新增操作记录 */
        addOptRecord() {
            var params = {
                "businessId": this.courseId,
                "businessType": 'course',
                "optType": OPERATIONTYPE[2]
            }
            AddOptRecord(params);
        },
        /**获取课程详情 */
        queryCourseDetail() {
            QueryCourseDetail({ id: this.courseId }).then(res => {
                if (res.code == 200) {
                    var data = {
                        label: 'detail',
                        value: res.data
                    }
                    this.$store.commit('course/changeCourseDetail', data);
                    localStorage.setItem('base_detail', JSON.stringify(res.data));
                }
            })
        },
        /**打开弹窗 */
        openDialog() {
            var dialog = this.$refs.evaluate0;
            if (dialog) {
                dialog.id = this.courseId;
                dialog.businessType = 'course';
                dialog.getQuestionnairesEvaluateList(() => {
                    dialog.dialogVisible = true;
                });
            }
        },
        /**课程章节信息查询 */
        getChapterTree() {
            var params = {
                "courseId": this.courseId,
                "courseLearningSource": "course_study",
                "openCourseId": this.$store.state.course.courseDetailData.detail.openCourseId
            };
            GetStudyChapterTree(params).then(res => {
                if (res.code == 200) {
                    var data = {
                        label: 'chapter',
                        value: res.data
                    }
                    this.$store.commit('course/changeCourseDetail', data);
                }
            })
        },
        /**播放视频 */
        playVideo() {
            if (this.detail.introduceVideoPreviewUrl) {
                var index = this.detail.introduceVideoPreviewUrl.indexOf('m3u8');
                const audio = document.getElementById("audio");
                if (index != -1) {
                    const hls = new Hls();
                    if (Hls.isSupported()) {
                        hls.loadSource(this.$severUrl(this.detail.introduceVideoPreviewUrl));
                        hls.attachMedia(audio);
                        hls.on(Hls.Events.MANIFEST_PARSED, function () {
                            audio.play();
                        });
                    } else if (audio.canPlayType("application/vnd.apple.mpegurl")) {
                        audio.src = this.$severUrl(this.detail.introduceVideoPreviewUrl);
                        audio.addEventListener("canplay", function () {
                            audio.play();
                        });
                    } else {
                        console.error("HLS is not supported in this browser");
                    }
                } else {
                    audio.src = this.$severUrl(this.detail.introduceVideoPreviewUrl);
                }
                this.isPlay = true;
            }
        },
        getInit() {
            this.addOptRecord();
            this.courseEvaluateList();
        }
    },
    computed: {
        detail() {
            return this.$store.state.course.courseDetailData.detail;
        },
        /**章节目录 */
        chapter() {
            return this.$store.state.course.courseDetailData.chapter;
        },
        userId() {
            return this.$store.state.user.userInfo.userId || this.$store.state.user.userInfo.id;
        }
    },
    destroyed() {
        this.$store.commit('backend/changePath', '');
    }
}
</script>

<style lang="less" scoped>
.tab-active {
    color: #387DFF !important;
}

.detail-box {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden ;
}

.title {
    color: #151C34;
    font-size: 2rem;
}

.course-data-box {
    padding: 2rem var(--padding) 10rem var(--padding);

    &> :nth-child(1) {
        padding: 8rem 3rem 3rem 3rem;
        background-color: #ffffff;
    }
}

.tab-box {
    display: flex;
    position: absolute;
    left: 3rem;
    top: 5rem;
    font-size: 1.8rem;

    &> :nth-child(n) {
        cursor: pointer;
        margin-left: 2rem;
    }

    &> :nth-child(1) {
        margin-left: 0rem;
    }
}

.top-box {
    // padding:16rem var(--padding) 0 var(--padding);
    position: relative;
}

.add {
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 6rem;
    cursor: pointer;
    z-index: 99;
}

.bottom-box {
    padding: 2rem 0 0 0;
    display: flex;

    &> :nth-child(1) {
        width: 74rem;
        background-color: #fff;
        padding: 3rem;
    }

    &> :nth-child(2) {
        flex: 1;
        margin-left: 2rem;
    }
}

.category-box {
    padding: 2rem var(--padding) 10rem var(--padding);

    &> :nth-child(1) {
        padding: 3rem;
        background-color: #ffffff;
    }
}

.bottom-container {
    padding: 2rem var(--padding) 10rem var(--padding);
    width: 100%;

    &> :nth-child(1) {
        padding: 3rem;
        background-color: #ffffff;
    }
}

.page-title {
    color: #0D0825;
    font-size: 2.6rem;
    font-weight: 700;
    width: 40rem;
}

.rate-box {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999999;
    font-size: 14px;

    &> :nth-child(1) {
        margin-top: 0.3rem;
    }

    &> :nth-child(2) {
        margin-left: 0.5rem;
    }

    i {
        cursor: pointer;
        font-size: 1.8rem;
        margin-left: 1rem;
    }
}

.img-box {
    display: flex;
    justify-content: center;
    position: relative;

    .img-detail {
        // height: 36rem;
        width: 70rem;
        object-fit: cover;
    }
}

/deep/.el-dialog__title {
    font-size: 16px;
    font-weight: 700;
    color: #334681;
}

/deep/.el-dialog__body {
    padding: 0 2rem;
}

.play-box {
    width: 12rem;
    height: 5rem;
    border: 1px solid #ffffff;
    border-radius: 10px;
    position: absolute;
    top: calc(50% - 2.5rem);
    color: #ffffff;
    left: calc(50% - 6rem);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
        font-size: 2.5rem;
    }
}

.edit {
    position: fixed;
    top: 20rem;
    right: 0;
    color: #ffffff;
    background: linear-gradient(to bottom, rgb(2, 73, 229), rgb(80, 156, 253));
    width: 6rem;
    height: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
    font-size: 2rem;
    cursor: pointer;
    z-index: 99;
}

.icon-fanhui1 {
    position: absolute;
    top: 16rem;
    left: 33rem;
    color: #000000;
    font-size: 2rem;
    cursor: pointer;
}

.one-box {
    background-color: #ffffff;
    padding: 3rem;
    display: flex;
    position: relative;
}

.name-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 3rem;
}

.one-right {
    margin-left: 6rem;
}

.ev {
    margin-left: 1rem;
    cursor: pointer;
}

/deep/.category-box {
    padding: 2rem 0 10rem 0 !important;
}

/deep/.course-data-box {
    padding: 2rem 0 10rem 0 !important;
}

/deep/.bottom-container {
    padding: 2rem 0 10rem 0 !important;
}
</style>